import { ILogger } from '@cian/logger';
import { ITelemetryLogger } from '@cian/telemetry/shared';
import { ISutochnoPilot } from '../../types/sutochnoPilot';
import { IMappers } from '../../repositories/billing-accounts/v1/get-sutochno-pilot-info';
import { map400Response } from '../../utils/serverErrors';
import { DEFAULT_RESPONSE } from './constants';

interface IMapperParams {
  telemetry: ITelemetryLogger;
  logger: ILogger;
}

export const mappers = (params: IMapperParams): IMappers<ISutochnoPilot, ISutochnoPilot> => {
  const { telemetry, logger } = params;

  return {
    200: response => {
      const { isPilotEnabled, regions } = response;

      telemetry.increment('get-sutochno-pilot-info.request.success');

      return {
        isPilotEnabled,
        regions,
      };
    },
    400: response => {
      logger.debug('400 ответ на запрос get-sutochno-pilot-info на Главной', {
        errors: map400Response(response),
      });

      telemetry.increment('get-sutochno-pilot-info.request.bad-request');

      return DEFAULT_RESPONSE;
    },
  };
};
